import React from 'react';
import styles from './style.scss';

function PremiumFeatureBanner() {
  return (
    <div className={styles.container}>
      To make this Premium Feature visible on your site, simply upgrade the app
    </div>
  );
}

export default PremiumFeatureBanner;



// WEBPACK FOOTER //
// ./src/widget/premium_feature_banner/index.js